<template>
  <div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		<div class="content">
		      <div class="content-main" v-if="info.no">
			        <div class="box-text" v-html="info.startContent">
			         	 
					 </div>
					 <div class="box-big-card">
			         	  <h3 class="name">추천 어휘</h3>
						  <ul>
			         	     <li v-for="data in dataList">
			         	        <div class="eng">{{data.eng}}</div>
								<div class="kor">{{data.kor}}</div>
			         	         <!--p class="text-card">{{data.rdate}}</p--> 
			         	     </li>
					 	  </ul>
			        </div>
					<div class="box-text"  v-html="info.endContent">
			        </div>
			  </div>
			  <div class="content-main" v-else style="height:500px;line-height:500px;text-align:center;padding:0;">
				<h3>추천 어휘 데이타가 존재하지 않습니다</h3>
			  </div>
	    </div>
	    <FooterLayout></FooterLayout>
	</div>
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
	name: 'AdvisorWord',
	components: {
		HeaderLayout,
		FooterLayout
	},
	data() {
		return {
			pagecode:'advisor',
			cmd:'word',
			dataList:[],
			info:{},

		}
	},
	created() {
		this.getData();
	},
    methods: {
	   getData() {
		  	var obj = this;
			this.$form.sendPost({cmd:'word'},'advisor/getDataList',function(resp) {
				if(resp.result=='succ') {
					obj.dataList = resp.dataList;
					obj.info = resp.info;

				} else {

				}
			},'multi');
	  
		},
		changePage(code) {
			switch(code) {
				case 'list':
					this.$router.push({path:'/advisor/list'});
				break;
				case 'sentence':
					this.$router.push({path:'/advisor/sentence'});
				break;
				case 'word':
					this.$router.push({path:'/advisor/word'});
				break;
				case 'problem':
					this.$router.push({path:'/advisor/gtest'});
				break;

			}
		}
	
	}
}
</script>

<style lang="scss" scoped>
*    {
     margin:0;
	 padding:0;
}
a    {
     text-decoration:none;
}
li    {
      list-style:none;
}


.page-container {
	width:100%;
	min-height:calc(100vh);
	background:#E6E8F4;
	.content   {
		width:100%;
		padding:180px 0 55px 0; 
		font-family: 'Nanum Gothic', sans-serif;
		.content-main	{
		                  width:830px;
						  margin:0 auto;
						  height:auto;
						  min-height:540px;
						  background:#fff;
						  padding:10px;
						  .box-text        {
						  		font-size:13px;
		                         color:#000;
								line-height:110%;
								height:auto;
								padding:20px;
								&:last-child        {
									padding-top:30px;
								}
						  }
						  .box-big-card     {
						  				   padding:10px 20px;
										   .name        {
										   		   font-size:14px;
		                         		           color:#3D79FE;
												   padding-bottom:10px;
										   }
										   ul     {
										   		li {
													width:100%;
													padding:13px;
													border-bottom:solid 1px #ccc;
													.eng {
														color:#000;
														font-weight:bold;
														font-size:12pt;
														padding-bottom:5px;
													}
												}		
														
										   }
						  }
		}
	}
}		
</style>